import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <>
      <SEO 
        title="Adgang nægtet" 
        description="Du har ikke tilladelse til at tilgå denne side." 
      />

      <section className="min-h-[70vh] flex items-center justify-center bg-brand-cream px-6 py-16">
        <div className="max-w-md w-full text-center flex flex-col items-center gap-6">
          <div className="w-16 h-16 rounded-full bg-brand-beige flex items-center justify-center text-brand-brown text-2xl">
            <i className="fa-light fa-lock" />
          </div>
          
          <div className="flex flex-col gap-2">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-brown/70">Fejl 403</span>
            <h1 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark">
              Adgang nægtet
            </h1>
          </div>

          <p className="text-brand-brown text-sm leading-relaxed">
            Beklager, men du har ikke de nødvendige tilladelser til at tilgå denne side eller ressource.
          </p>

          <Link
            to="/"
            className="px-6 py-3 bg-brand-dark text-brand-cream font-medium rounded-brand hover:bg-brand-brown transition-colors duration-200 shadow-md"
          >
            Gå til forsiden
          </Link>
        </div>
      </section>
    </>
  );
}
